import { render, staticRenderFns } from "./activityBase.vue?vue&type=template&id=33946f7e&scoped=true"
import script from "./activityBase.vue?vue&type=script&lang=js"
export * from "./activityBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33946f7e",
  null
  
)

export default component.exports